module.exports = __webpack_public_path__ + "img/服务记录.43b5e7b9.png";